export default __webpack_public_path__ + "static/media/footer5.11a468f4.png";